"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var PlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M560 176a48 48 0 10-96 0v288H176a48 48 0 000 96h288v288a48 48 0 0096 0V560h288a48 48 0 000-96H560V176z" } }] }, "name": "plus", "theme": "outlined" };
exports.default = PlusOutlined;
